import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import GetIcon from "../font-awesome-icon";
import UIButton from "../ui-controls/button";
import { useRouter } from "next/router";

const GoBack = ({
  onClick,
  title,
  icon = faChevronLeft,
  sx = {},
  url = "",
  disabled = false,
}) => {
  const router = useRouter();
  return (
    <UIButton
      disabled={disabled}
      onClick={() => {
        onClick
          ? onClick()
          : url !== ""
            ? router.push(`/crm/analytics/reports`)
            : router.back();
      }}
      variant={"text"}
      disableRipple={true}
      sx={{
        p: 0,
        minHeight: 0,
        color: "var(--palette-secondary_button_text)",
        "&:hover": { background: "none !important" },
        ...sx,
      }}
    >
      <GetIcon title={title || ""} icon={icon} />
    </UIButton>
  );
};
export default GoBack;
